import { useCheckEmailExistPersonalQuery } from '@haaretz/s-lgn-queries/CheckEmailExist';
function useCheckEmailExist(variables, options) {
    const checkUserExist = useCheckEmailExistPersonalQuery(variables, options);
    return checkUserExist;
}
useCheckEmailExist.getKey = useCheckEmailExistPersonalQuery.getKey;
useCheckEmailExist.fetcher = useCheckEmailExistPersonalQuery.fetcher;
export default useCheckEmailExist;

//# sourceMappingURL=useCheckExistUser.js.map